<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      {{ 'SHARED.DISCONNECT_MODAL.TITLE' | translate : { source: source } }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="content">
      {{ 'SHARED.DISCONNECT_MODAL.TEXT' | translate : { source: source } }}
    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-stroked-button class="cancel-button button" [mat-dialog-close]="false">
      {{ 'COMMON.CANCEL' | translate }}
    </button>
    <button mat-flat-button color="primary" class="primary-button button" [mat-dialog-close]="true">
      {{ 'COMMON.DISCONNECT' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
